import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConcretePlan } from 'src/app/pages/new-billing/models/plan.model';
import { PlanActionType, PricePeriodicity } from 'src/app/pages/new-billing/types/plan.types';
import { PlanStateService } from 'src/app/services/billing/plan-state.service';
import { PlanCardClickEvent } from '../plan-card/plan-card.component';

@Component({
  selector: 'app-choose-plan-buttons',
  templateUrl: './choose-plan-buttons.component.html',
  styleUrls: ['./choose-plan-buttons.component.scss'],
})
export class ChoosePlanButtonsComponent {
  @Input() currentPlan: ConcretePlan;
  @Input() isV2 = false;
  @Input() plan: ConcretePlan;
  @Input() isCurrentPlan: boolean;
  @Input() payRecurrence: PricePeriodicity;
  @Input() nextPaymentDateFormatted: string;
  @Input() determinePlanState: () => PlanActionType;
  @Input() getTrackingData: (action: 'upgrade' | 'downgrade') => any;
  @Input() useChoosePlan = false;
  @Input() isAddCardExperiment = false;

  @Output() planCardBtnClick = new EventEmitter<PlanCardClickEvent>();

  constructor(private readonly planStateService: PlanStateService) {}

  public handlePlanCardBtnClick() {
    // Guard against null/undefined plan
    if (!this.plan) {
      return;
    }

    const actionType = this.determinePlanState?.();

    // Don't proceed if we can't determine a valid plan state
    if (!actionType) {
      return;
    }

    const plan = this.plan.clone();
    plan.switchPlanRecurrence(this.payRecurrence);

    this.planCardBtnClick.emit({
      plan,
      actionType,
    });
  }

  get futureSubscription(): boolean {
    const cardPlanName = this.planStateService.determineCardPlanName(this.plan.name, this.payRecurrence);
    return this.planStateService.isFutureSubscription(this.plan, this.currentPlan, cardPlanName);
  }

  get isCurrentPlanOrNoCard(): boolean {
    return this.isCurrentPlan || !this.currentPlan?.paymentModel?.cardLast4;
  }

  get isCurrentPlanOrAddCard(): boolean {
    return this.isCurrentPlan || this.buttonState === 'addCard';
  }

  get isChoosePlanButton(): boolean {
    return this.buttonState === 'choosePlan';
  }

  get isCurrentPlanWithCard(): boolean {
    return this.isCurrentPlan && !!this.currentPlan?.paymentModel?.cardLast4;
  }

  get buttonState(): 'addCard' | 'nextPayment' | 'choosePlan' {
    if (!this.currentPlan?.paymentModel?.cardLast4) {
      return 'addCard';
    }
    if (this.isCurrentPlan) {
      return 'nextPayment';
    }
    return 'choosePlan';
  }

  getChoosePlanTrackData() {
    return {
      page: 'Clicked Choose Plan',
      terms: this.payRecurrence === 'year' ? 'annually' : 'monthly',
      plan: this.plan.productId,
      price: this.plan.unitPrice,
    };
  }
}
